import { v4 as uuid } from 'uuid';
import { toUUID } from '../../util/transform';
import type { ITicketLoanDetailsSplit } from './TicketLoanDetailsSplit.interface';

export default class TicketLoanDetailsSplit implements ITicketLoanDetailsSplit {
  id: string;
  amount: number;
  product: string;
  interestRate: number;
  accountNumber: string;
  loanType: boolean;
  interestRateType: boolean;
  fixedYears: number;
  repaymentType: boolean;
  ioYears: number;
  lineOfCredit: boolean;

  static build = (data: ITicketLoanDetailsSplit) => new TicketLoanDetailsSplit(data);
  static blank = () => new TicketLoanDetailsSplit({ id: uuid() });

  /**
   * Constructor
   * @param {ITicketLoanDetailsSplit} data
   */
  constructor(data?: ITicketLoanDetailsSplit) {
    this.id = toUUID(data?.id) || uuid();
    this.amount = parseFloat(data?.amount || 0);
    this.product = data?.product || '';
    this.interestRate = parseFloat(data?.interestRate || 0);
    this.accountNumber = data?.accountNumber || '';
    this.loanType = data?.loanType === true;
    this.interestRateType = data?.interestRateType === true;
    this.fixedYears = parseInt(data?.fixedYears || 0, 10);
    this.repaymentType = data?.repaymentType === true;
    this.ioYears = parseInt(data?.ioYears || 0, 10);
    this.lineOfCredit = data?.lineOfCredit === true;
  }
}
